'use strict';
// @ts-check
/* global $ module require plupload */
declare var $;

import {ArtworkUploader} from './artwork_uploader';

/**
 * Class to initialize a set of artwork uploaders for the configuration.
 */
export class ConfigArtworkUploader {
    /**
     * @var {string} extension_string comma delimited string of file accepted file extensions.
     * @var {string} configuration_id id for the configuration.
     * @var {number} image_count number of artworks uploads for the configuration.
     * @var {HTMLAnchorElement} modal_opener <a> tag that will open the modal when clicked.
     * @var {HTMLButtonElement} modal_closer <button> element that closes the modal when clicked.
     * @var {Array<ArtworkUploader>} uploaders container for all of the artwork uploader objects.
     */
    extension_string: string;
    configuration_id: string;
    image_count: number;
    modal_opener: HTMLAnchorElement;
    modal_closer: HTMLButtonElement;
    uploaders: Array<ArtworkUploader>;

    /**
     * The constructor for the class.
     *
     * @param {string} config_id
     * @param {string} extension_string comma delimited string of file accepted file extensions.
     * @returns {ConfigArtworkUploader}
     */
    constructor(config_id: string, extension_string: string, initialize: boolean = true, number_of_designs: number = 1) {
        this.configuration_id = config_id;
        this.extension_string = extension_string;
        this.image_count = number_of_designs;
        this.modal_opener = null;
        this.uploaders = [];

        if (initialize) {
            this.bind();
            this.init_uploaders();
        }

    }

    /**
     * Binds the modal opener and closer and sets the image count (number of designs) for the configuration.
     */
    bind(): void {
        this.modal_opener = <HTMLAnchorElement> document.getElementById(`js-cart-artwork-upload-modal-opener-${this.configuration_id}`);
        this.modal_closer = <HTMLButtonElement> document.getElementById(`js-artwork-upload-modal-close-${this.configuration_id}`);
        if (this.modal_closer) {
            this.modal_closer.addEventListener('click', () => {
                $.ceDialog('get_last').ceDialog('close');
            });
        }
        const image_count_input = <HTMLInputElement> document.getElementById(
            `js-cart-uploader-image-count-${this.configuration_id}`
        );
        if (image_count_input) {
            const image_count = Number(image_count_input.value);
            this.image_count = image_count > 0 ? image_count : 1;
        }
    }

    /**
     * Reinitialize the artwork uploaders for a configuration, called when there is a reconfig.
     */
    reinitialize(): void {
        this.bind();
        this.destroy_uploaders();
        this.uploaders = [];
        this.init_uploaders();
    }

    /**
     *Destroy the old artwork uploaders for a configuration.
     */
    destroy_uploaders(): void {
        for (const uploader of this.uploaders) {
            uploader.destroy_uploader();
        }
        this.uploaders = [];
    }

    /**
     * Initializes an artwork uploader instance for each artwork design in a configuration.
     *
     * @returns {void}
     */
    init_uploaders(): void {
        for (let i = 0; i < this.image_count; i += 1) {
            const params = {
                'configuration_id': this.configuration_id,
                'image_index': i
            };

            // eslint-disable-next-line no-new
            this.uploaders.push(
                new ArtworkUploader(
                    params,
                    `${this.configuration_id}-${i}`,
                    '/index.php?dispatch=tv_artwork.upload_from_cart',
                    this.extension_string
                )
            );
        }

    }
}
